export default __webpack_public_path__ + "static/media/about2.8defa1f9.jpg";